import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { PreloadAllModules, provideRouter, withHashLocation, withPreloading } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { errorInterceptor } from './core/interceptors/error.interceptor';
const firebaseConfig = {
  apiKey: "AIzaSyB0grPBmVgqw0oy0RYrOs8SbfP38_SRABY",
  authDomain: "topedoxpartner-d031a.firebaseapp.com",
  projectId: "topedoxpartner-d031a",
  storageBucket: "topedoxpartner-d031a.firebasestorage.app",
  messagingSenderId: "249187449203",
  appId: "1:249187449203:web:78ffca783b0dacce22ed06",
  measurementId: "G-NR39FJPSL4"
};
export const appConfig: ApplicationConfig = {
  providers: [provideHttpClient(), provideAnimations(), provideHttpClient(withInterceptors([authInterceptor])),
  // provideHttpClient(
  //   withInterceptors([errorInterceptor])
  // ),
  provideRouter(
    routes,
    withHashLocation(),
    withPreloading(PreloadAllModules)   // ✅ Correct syntax
  ),

  provideToastr({
    timeOut: 2000,
    positionClass: 'toast-top-right',
    closeButton: true,
    preventDuplicates: true,
  }),
  provideFirebaseApp(() => initializeApp(firebaseConfig)),
  provideMessaging(() => getMessaging()),
  ]
};
